import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  getExerciseDialogue,
  getTranslations,
  exerciseAsyncActions
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import DefaultIcon from 'assets/image/common/default.png';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';

export const ExerciseChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    exerciseDialogue
  } = useSelector((state: IStore) => state.exercise);
  const dispatch = useDispatch();
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId) {
      dispatch(exerciseAsyncActions[getExerciseDialogue](Number(dialogueId)));
    }
  }, [dialogueId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/exercise">
        <FormattedMessage
          id={'gritx.exercise.breadcrumb.previous'}
          defaultMessage="Exercise"
        />
      </Link> {exerciseDialogue && <span className="exercise-chat__title-dialogue-name"> - {exerciseDialogue.dialogName}</span>}
    </div>;
  }

  return <div className="exercise-chat">
    {
      !loading.includes(getTranslations) && exerciseDialogue && <>
        <h1 className="exercise-chat__title">
          <img src={DefaultIcon} alt="" className="exercise-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat mode={BotType.Xpedition} dialogueId={exerciseDialogue.dialogId} title={exerciseDialogue.dialogName} />
      </>
    }
  </div>;
};
